<template>
  <v-container fluid>
    <v-layout justify-space-between>
      <v-flex>
        <h1>
          BPI Satellite Configuration 
          <v-btn v-show="!loggedIn" icon @click="reload">
            <v-icon>refresh</v-icon>
          </v-btn>
        </h1>
      </v-flex>
      <v-flex text-xs-right>
        <v-btn v-show="loggedIn" @click="createConfig" color="secondary"><v-icon>add</v-icon> New configuration</v-btn>
      </v-flex>
    </v-layout>
    <v-flex>
      <a class="text--secondary" target="_blank" href="https://usedca.atlassian.net/wiki/spaces/US/pages/538640391/Satellite+Configuration">See confluence page for details on satellite configuration model</a>
    </v-flex>
    <v-layout row justify-center py-4>
      <v-flex xs10>
        <v-combobox
          :disabled="!loggedIn"
          label=""
          placeholder="Search for BPI Satellite Site"
          clearable
          solo
          :items="list"
          item-text="site"
          color="secondary"
          v-model="config"
          hide-details
          :loading="loading"
        >
        </v-combobox>
      </v-flex>
    </v-layout>
    <v-layout v-if="config" column>
      <v-layout row align-center justify-space-between>
        <v-btn small outline @click="goLeft" icon>
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <span>
          {{config.site}}
          <v-btn small v-if="!putOrPost"  @click="editConfig" icon color="secondary">
            <v-icon small>edit</v-icon> 
          </v-btn>
          <v-menu
            v-model="showDelete"
            v-if="putOrPost"
            offset-x
          >
            <v-btn slot="activator" color="error">
              Delete
            </v-btn>
            <v-card>
              <v-list>
                <v-list-tile>
                  <v-list-tile-content>
                    Are you sure you want to delete <span style="font-weight:bold">{{configData.site}}</span>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider></v-divider>
              <v-card-actions>
                <v-btn color="secondary" @click="deleteConfig">Confirm</v-btn>
                <v-btn color="primary" @click="showDelete = false">Cancel</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </span>
        <v-btn small outline @click="goRight" icon>
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-layout>
      <v-layout column v-if="!putOrPost" py-3>
        <v-flex class="grey darken-3" pa-4 style="position:relative">
          <pre>{{config}}</pre>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout v-if="loggedIn && putOrPost" py-3 row wrap>
      <v-flex xs12 pb-3>
        <h3>{{getPutOrPost}}</h3>
      </v-flex>
      <v-flex xs6 shrink>
        <satellite-configuration-form
          v-model="configData"
          :required-fields="requiredFields"
          :edit="!isPost"
        ></satellite-configuration-form>
      </v-flex>
      <v-flex xs6 pl-3 shrink>
        <v-layout column>
          <v-flex>
            Data 
            <pre class="grey darken-3 pa-4">{{configData}}</pre>
          </v-flex>
          <v-layout text-xs-right justify-end align-center>
            <v-fade-transition>
              <v-icon v-show="apiSuccess" large color="accent">check_circle</v-icon>
            </v-fade-transition>
            <v-fade-transition>
              <v-icon v-show="apiError" large color="error">error</v-icon>
            </v-fade-transition>
            <v-btn @click="submit" :loading="disableSubmit" :disabled="disableSubmit" color="secondary">{{getActionText}}</v-btn>
            <v-btn @click="putOrPost = !putOrPost" color="primary">Cancel</v-btn>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout column pt-5 v-show="apiResponse" align-center fill-height>
      <v-flex>
        <v-fade-transition>
          <v-icon v-show="apiSuccess" large color="accent">check_circle</v-icon>
        </v-fade-transition>
        <v-fade-transition>
          <v-icon v-show="apiError" large color="error">error</v-icon>
        </v-fade-transition>
      </v-flex>
      <v-flex>
        API Response:
      </v-flex>
      <v-flex><pre class="grey darken-4 pa-3">{{apiResponse}}</pre></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import SatelliteConfigurationForm from '@/components/SatelliteConfigurationForm'
export default {
  name: "Satellite",
  components: {
    SatelliteConfigurationForm,
  },
  data: () => ({
    list: [],
    config: null,
    loading: true,
    apiResponse: null,
    apiSuccess: false,
    apiError: false,
    configData: null,
    putOrPost: false,
    showDelete: false,
    disableSubmit: false,
    isPost: false,
    configDefaults: {
      site: '',
      title: '',
      default_search_location: '',
      post_location: {
        latitude: 0,
        longitude: 0
      },
    },
    requiredFields: [
      'site', 'title', 'default_search_location', 'post_location'
    ]
  }),
  mounted () {
    this.reload()
  },
  methods: {
    reset() {
      this.list = []
      this.config = null
    },
    deleteConfig (){
      this.$api.deleteSatelliteSiteConfiguration(this.configData.site).then((result) => {
        this.goRight()
        this.showSuccess()
        this.reload()
        this.apiResponse = result
      }).catch((error) => {
        this.showError()
        this.apiResponse = error.response
      }).then(()=>{
      })
    },
    editConfig () {
      this.configData = this.config
      this.putOrPost = true
      this.isPost = false
    },
    createConfig () {
      this.config = null
      this.isPost = true  
      this.$nextTick(()=>{
        this.configData = this.configDefaults
        this.putOrPost = true
      })
    },
    reload() {
      this.loading = true
      this.$api.getSatelliteConfiguration().then((results)=>{
        this.list = results.data
      }).catch((error) => {
        this.apiResponse = error.response
      }).then(()=>{
        this.loading = false
      })
    },
    goLeft() {
      let idx = this.list.indexOf(this.config)
      let left_idx = idx - 1 < 0 ? this.list.length - 1 : idx - 1
      this.config = this.list[left_idx]
    },
    goRight() {
      let idx = this.list.indexOf(this.config)
      let right_idx = idx + 1 == this.list.length ? 0 : idx + 1
      this.config = this.list[right_idx]
    },
    showSuccess () {
      this.apiSuccess = true
      setTimeout(()=>{
        this.apiSuccess = false
      }, 2000)
    },
    showError() {
      this.apiError = true
      setTimeout(()=>{
        this.apiError = false
      }, 2000)
    },
    submit () {
      this.disableSubmit = true
      if (this.isPost) {
        this.$api.postSatelliteSiteConfiguration(this.configData).then((result)=>{
          this.reload()
          this.showSuccess()
          this.putOrPost = false
          this.apiResponse = result
          this.config = result.data
        }).catch((error)=>{
          this.showError()
          this.apiResponse = error.response
        }).then(()=>{
          this.disableSubmit = false
        })
      } else {
        this.$api.putSatelliteSiteConfiguration(this.configData.site, this.configData).then((result) => {
          this.showSuccess()
          this.reload()
          this.apiResponse = result
          this.config = result.data
        }).catch((error) => {
          this.showError()
          this.apiResponse = error.response
        }).then(()=>{
          this.disableSubmit = false
        })
      }
    }
  },
  computed: {
    loggedIn() {
      let status = this.$store.getters.isLoggedIn
      this.apiResponse = null
      if (status) {
        this.reload()
      } else {
        this.reset()
      }
      return status
    },
    getConfigData () {
      return this.configData
    },
    getPutOrPost () {
      if (this.isPost) {
        return "Creating new satellite configuration"
      }
      return "Editing satellite configuration for " + this.configData.site
    },
    getActionText () {
      return this.isPost ? "Save" : "Update"
    }
  },
  watch: {
    config: function (val) {
      this.configData = this.config
      this.putOrPost = false
    }
  }
}
</script>
<style lang="stylus" scoped>
button {
  font-weight:800
}
pre {
  position:relative;
}
.editButton {
  position:absolute;
  top:0;
  right:0
}
</style>